import Textfield from "../Input/Textfield";
import { useFormContext } from "react-hook-form";
import { emailPattern } from "@/shared/utils/patterns";
import { useTranslation } from "react-i18next";
import usePosOrderUser from "@/shared/atoms/usePosOrderUser";
import useValidatePhoneNumber from "@/shared/hooks/useValidatePhoneNumber";

const PosPaymentEmailOrSms = ({ isShown }: { isShown: boolean }) => {
  const { register, errors, clearErrors, watch } = useFormContext();
  const validatePhoneNumber = useValidatePhoneNumber();
  const { t } = useTranslation("", {
    keyPrefix: "posOrders",
  });
  const { t: tGlobal } = useTranslation("");
  const [orderUser] = usePosOrderUser();

  if (!isShown) return null;
  return (
    <div className="flex flex-col  gap-3 mb-3">
      <div>{t("onlineOrderEmailWarning")}</div>
      <div className="mb-4 grid grid-cols-2 gap-2">
        <Textfield
          name="telephone"
          placeholder={t("telephone")}
          ref={register({
            validate: (value) => {
              const emailValue = watch("email");
              if (
                (!value || value === "") &&
                (!emailValue || emailValue === "")
              ) {
                return tGlobal("fieldRequired");
              } else if (value && validatePhoneNumber(value) === false) {
                return tGlobal("smsIsNotCorrect");
              } else {
                clearErrors("email");
                return true;
              }
            },
          })}
          defaultValue={orderUser?.telephone}
          error={errors?.telephone?.message}
        />
        <Textfield
          name="email"
          placeholder={t("email")}
          ref={register({
            validate: (value) => {
              const telValue = watch("telephone");
              if ((!value || value === "") && (!telValue || telValue === "")) {
                return tGlobal("fieldRequired");
              } else if (value && emailPattern.test(value) === false) {
                return tGlobal("emailIsNotCorrect");
              } else {
                clearErrors("telephone");
                return true;
              }
            },
          })}
          defaultValue={orderUser?.email}
          error={errors?.email?.message}
        />
      </div>
    </div>
  );
};

export default PosPaymentEmailOrSms;
